import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { ROUTES } from '../config';
import { useAuth } from '../lib/auth';
import PublicComplaintsAuth from '../pages/complaints/PublicComplaintsAuth.jsx';

function isComplaintsDeskPath(pathname) {
  if (!pathname || !pathname.startsWith('/complaints')) return false;
  // SSO has its own public route above this guard.
  if (pathname.startsWith('/complaints/sso/login')) return false;
  return true;
}

/**
 * Route guard — bounces unauthenticated users to /login, except the
 * tenant complaints desk.  When public complaint login is enabled the
 * visitor sees a create-account / sign-in form at /complaints instead
 * of the staff login; when it is off, that form itself redirects here.
 */
export default function RequireAuth({ children }) {
  const { isAuthenticated, bootstrapping } = useAuth();
  const location = useLocation();

  if (bootstrapping) {
    return (
      <div className="ty-fullscreen-center">
        <div className="ty-spinner" aria-label="Loading" />
      </div>
    );
  }

  if (!isAuthenticated) {
    if (isComplaintsDeskPath(location.pathname)) {
      return <PublicComplaintsAuth />;
    }
    return <Navigate to={ROUTES.LOGIN} replace state={{ from: location }} />;
  }
  return children;
}
